// lazy-image.service.ts

import { Injectable } from '@angular/core';
import { LazyImageComponent } from '../components/lazy-image/lazy-image.component';

@Injectable({ providedIn: 'root' })
export class LazyImageService {
  private pendingComponents: Set<LazyImageComponent> = new Set();
  private debounceTimer: any;

  registerComponent(component: LazyImageComponent) {
    this.pendingComponents.add(component);
    this.scheduleLoading();
  }

  private scheduleLoading() {
    if (this.debounceTimer) return;

    this.debounceTimer = setTimeout(() => {
      // console.log('LazyImageService | scheduleLoading()');
      this.loadAll();
      this.debounceTimer = null;
    }, 1000); // 1500ms debounce
  }

  private loadAll() {
    this.pendingComponents.forEach(component => component.forceLoad());
    this.pendingComponents.clear();
  }
}